<template>
  <a-modal
    title="新建储值卡"
    :width="780"
    :visible="visible"
    :confirmLoading="loading"
    @ok="() => { $emit('ok') }"
    @cancel="() => { $emit('cancel') }"
  >
    <a-spin :spinning="loading">
      <a-form :form="form">
        <a-row :gutter="[16,16]">
          <a-col :span="12">
            <a-form-item label="开始卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input style="width: 100%;" :maxLength="20" v-decorator="['card_no_start', {rules: [{ required: true, message: '请输入', pattern: /^\d+$/ }]}]" @change="cardNoStartChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="结束卡号" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input style="width: 100%;" :maxLength="20" v-decorator="['card_no_end', {rules: [{required: true, message: '请输入', pattern: /^\d+$/}]}]" @change="cardNoEndChange"/>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="批次" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['batch', {rules: [{ required: true, message: '请输入' }]}]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="金额" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number :min="0" v-decorator="['value', {rules: [{required: true, message: '请输入'}]}]"/>
              <span style="padding-left: 10px;">元</span>
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item label="数量" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input-number disabled :min="1" v-decorator="['count', {rules: [{ required: true, message: '请输入'}]}]" />
              <span style="padding-left: 10px;">张</span>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import pick from 'lodash.pick'
import moment from 'moment/moment'

const fields = ['card_no_start', 'card_no_end', 'count', 'value', 'batch']
export default {
  name: 'CreateValueCardForm',
  components: {
  },
  props: {
    model: {
      type: Object,
      default: () => ({})
    },
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: () => false
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 17 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this)
    }
  },
  mounted () {
    this.$nextTick(() => {
      if (this.model !== null) {
        this.loadEditInfo(this.model)
      }
      this.handleGenerateBatch()
    })
  },
  methods: {
    loadEditInfo (data) {
      const { form } = this
      const formData = pick(data, fields)
      console.log('formData', formData)
      form.setFieldsValue(formData)
    },
    handleGenerateBatch () {
      const today = moment()
      const year = today.year()
      const month = today.month() + 1 // 注意月份从0开始，所以要加1
      const date = today.date() > 9 ? today.date() : '0' + today.date()
      console.log(date)
      this.form.setFieldsValue({
        batch: '' + year + month + date
      })
    },
    countCommonStart (str1, str2) {
      const length = Math.min(str1.length, str2.length)
      for (let i = 0; i < length; i++) {
        if (str1[i] !== str2[i]) {
          return i
        }
      }
      return length
    },
    cardNoStartChange (e) {
      const end_no = this.form.getFieldValue('card_no_end')
      const start_no = e.target.value
      if (start_no === undefined || end_no === undefined) {
        return
      }
      if (end_no.length !== start_no.length) {
        return
      }
      const equalIndex = this.countCommonStart(start_no, end_no)
      const count = Number(end_no.substring(equalIndex)) - Number(start_no.substring(equalIndex))
      if (count < 0) {
        return
      }
      this.form.setFieldsValue({
        count: count + 1
      })
    },
    cardNoEndChange (value) {
      const start_no = this.form.getFieldValue('card_no_start')
      const end_no = value.target.value
      if (start_no === undefined || end_no === undefined) {
        return
      }
      if (end_no.length !== start_no.length) {
        return
      }
      const equalIndex = this.countCommonStart(start_no, end_no)
      const count = Number(end_no.substring(equalIndex)) - Number(start_no.substring(equalIndex))
      if (count < 0) {
        return
      }
      this.form.setFieldsValue({
        count: count + 1
      })
    }
  }
}
</script>
